import { ReactComponent as TrashSvg } from '../../assets/icons/trash.svg';

export const TrashIcon: SvgIcon = (props) => {
    return <TrashSvg {...props} />;
};
